import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { createOrUpdateUserBasicProfilesDetailsGraphQlMutation } from '../../../graphQL/NiatApplicationPortal/mutations/createOrUpdateUserBasicProfilesDetails';
import {
  MutationGraphQlResponseType,
  UpdateUserProfileDetailGraphQlRequestObjectType
} from '../../../services/IbUserAccountsServices/GraphQlService/types';

import { useIbUserAccountsGraphQLService } from '../useIbUserAccountsGraphQLService';

interface UseUpdateUserProfileDetailsGraphQlInterface {
  updateUserProfileDetailsGraphQLApi: UseMutateAsyncFunction<
    MutationGraphQlResponseType,
    Error,
    UpdateUserProfileDetailGraphQlRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useUpdateUserProfileDetailsGraphQl =
  (): UseUpdateUserProfileDetailsGraphQlInterface => {
    const { ibUserAccountsGraphQLService } = useIbUserAccountsGraphQLService();

    const updateUserProfileDetails = (
      data: UpdateUserProfileDetailGraphQlRequestObjectType
    ) => {
      const mutationDetail =
        createOrUpdateUserBasicProfilesDetailsGraphQlMutation();

      return ibUserAccountsGraphQLService.ibUserAccountsGraphQlMutation(
        mutationDetail.mutation,
        {
          user_basic_details_input: data
        }
      );
    };

    const { mutateAsync, error, status } = useMutation(
      updateUserProfileDetails,
      {
        mutationKey: ['updateUserProfileDetailsGraphQLApi']
      }
    );

    return {
      updateUserProfileDetailsGraphQLApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useUpdateUserProfileDetailsGraphQl };
